module.exports = __webpack_public_path__ + "img/app_icon_52.519c3fcf.png";